import { EchoConversation as SmsForm } from "@bgea-js/form-templates";
import "../../../../src/content/sms-verse-of-the-day/smsVerse.scss";
import * as React from 'react';
export default {
  SmsForm,
  React
};